import CardBox from "./CardBox.vue";
import Filtro from "./Filtro.vue";
import ScrollContainer from "./ScrollContainer.vue";
import ScrollPaginado from "./ScrollPaginado.vue";

import Header from "./HcHeader.vue";
import Main from "./HcMain.vue";
import Card from "./HcCard.vue";
import CardBody from "./HcCardBody.vue";

import Modal from "./HcModal.vue";
import Accordion from "./Accordion.vue";
import AccordionItem from "./AccordionItem.vue";

import Tabs from "./Tabs.vue";
import TabContent from "./TabContent.vue";

export const HcAccordion = Accordion;
export const HcAccordionItem = AccordionItem;

export const HcTabs = Tabs;
export const HcTabContent = TabContent;

export const HcModal = Modal;
export const HcMain = Main;
export const HcHeader = Header;
export const HcCard = Card;
export const HcCardBody = CardBody;
export const HcCardBox = CardBox;
export const HcFiltro = Filtro;
export const HcScrollContainer = ScrollContainer;
export const HcScrollPaginado = ScrollPaginado;

